export default "__VITE_ASSET__C62REzi7__"